export default "__VITE_ASSET__VAkTJvPJ__"